"use client";
import { trackCalendlyClick } from "@/lib/analytics";

interface CalendlyLinkProps {
  location: string;
  className?: string;
  children: React.ReactNode;
}

export default function CalendlyLink({ location, className, children }: CalendlyLinkProps) {
  const handleClick = () => {
    trackCalendlyClick(location);
  };

  return (
    <a 
      href="https://calendly.com/varun-shetty2893/30min" 
      target="_blank" 
      rel="noopener noreferrer" 
      className={className}
      onClick={handleClick}
    >
      {children}
    </a>
  );
}
